import { render, staticRenderFns } from "./suitch-wallpaper-widget.vue?vue&type=template&id=777c381c&"
import script from "./suitch-wallpaper-widget.vue?vue&type=script&lang=js&"
export * from "./suitch-wallpaper-widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports